/** Flat page section: heading with a rule, optional count, lead text and right-hand actions. */
import type { ReactNode } from 'react'

interface SectionProps { title: ReactNode; count?: number; lead?: ReactNode; aside?: ReactNode; children: ReactNode; id?: string }

export function Section({ title, count, lead, aside, children, id }: SectionProps) {
  return (
    <section className="section" id={id}>
      <div className="section-head">
        <h2>{title}{count !== undefined && <span className="count">{count}</span>}</h2>
        {aside && <div className="row">{aside}</div>}
        {lead && <div className="lead">{lead}</div>}
      </div>
      {children}
    </section>
  )
}

/** Collapsible block for secondary information (brief, activity, earlier packages). */
export function Fold({ title, count, open, children }: { title: ReactNode; count?: number | string; open?: boolean; children: ReactNode }) {
  return (
    <details className="fold" open={open}>
      <summary>{title}{count !== undefined && <span className="count">· {count}</span>}</summary>
      <div className="fold-body">{children}</div>
    </details>
  )
}
